<p-breadcrumb
  styleClass="customBreadcrumb"
  class="w-full max-w-full"
  [model]="breadcrumpsService.breadcrumbs()"
  [home]="home"
>
  <ng-template #item let-item>
    @if (item.route) {
      <a [routerLink]="item.route" class="p-breadcrumb-item-link">
        <span [ngClass]="[item.icon ? item.icon : '', 'text-color']"></span>
        <span class="text-primary font-semibold">{{ item.label }}</span>
      </a>
    } @else if (item.url && item.label) {
      <a [href]="item.url">
        <span class="text-color">{{ item.label }}</span>
      </a>
    }
  </ng-template>
</p-breadcrumb>
